import { type IBaseWidget } from '../../IBaseWidget.ts';
import {
  type ISortableWidgetData,
  type Widget,
  WidgetMainType,
  type WidgetOrRoot,
} from '../../Widget.ts';
import { WidgetRepository } from '../WidgetRepository.ts';

/**
 * Elemento generico di tipo container
 */
export interface IContainerWidget extends IBaseWidget {
  id: string;
  children: Widget[];
}

export function isContainer(
  widget: WidgetOrRoot | null | undefined,
): widget is Widget & IContainerWidget {
  if (!widget) return false;
  return (
    WidgetRepository.find(widget.type)?.mainType === WidgetMainType.Container
  );
}

/**
 * Ritorna vero se i dati del widget forniti si riferiscono
 * a un widget di tipo container
 */
export function isContainerData(data: ISortableWidgetData | undefined) {
  if (!data) return false;
  return (
    WidgetRepository.find(data.type)?.mainType === WidgetMainType.Container
  );
}
